import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  key: 0,
  class: "colecctivos"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = {
  key: 1,
  class: "ajedrez"
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "Modalidad", -1)
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "Categoría", -1)
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "ELO FIDE", -1)
const _hoisted_21 = { class: "col-sm-6" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "TITLE FIDE", -1)
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = {
  key: 0,
  class: "row"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "ID FIDE", -1)
const _hoisted_27 = { class: "col-sm-6" }
const _hoisted_28 = {
  key: 2,
  class: "atletismo"
}
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "Competencia", -1)
const _hoisted_31 = { class: "col-sm-6" }
const _hoisted_32 = {
  key: 0,
  class: "row"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "Categoría", -1)
const _hoisted_34 = { class: "col-sm-6" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "Pruebas", -1)
const _hoisted_37 = { class: "col-sm-6" }
const _hoisted_38 = { class: "d-flex" }
const _hoisted_39 = {
  key: 0,
  class: "me-1"
}
const _hoisted_40 = {
  key: 1,
  class: "row"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "Total olímpico", -1)
const _hoisted_42 = { class: "col-sm-6" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h6", { class: "h6 my-4" }, "Mis pruebas", -1)
const _hoisted_45 = { class: "d-flex" }
const _hoisted_46 = {
  key: 0,
  class: "me-1"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-2 text-hover-danger me-4" }, null, -1)
const _hoisted_48 = {
  key: 3,
  class: "TKD"
}
const _hoisted_49 = { class: "row" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4" }, "Competencia", -1)
const _hoisted_51 = { class: "col-sm-8" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4" }, "Pruebas", -1)
const _hoisted_54 = { class: "col-sm-8" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("h6", { class: "h6 my-4" }, "Mis pruebas seleccionadas", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-2 text-hover-danger me-4" }, null, -1)
const _hoisted_58 = {
  key: 4,
  class: "tenis"
}
const _hoisted_59 = {
  key: 0,
  class: "row"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4" }, "Seleccione si tiene ranking", -1)
const _hoisted_61 = { class: "col-sm-8" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4" }, "Competencia", -1)
const _hoisted_64 = { class: "col-sm-8" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4" }, "Modalidad", -1)
const _hoisted_67 = { class: "col-sm-8" }
const _hoisted_68 = {
  key: 1,
  class: "row"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4" }, "Orden de fuerza tenimesista", -1)
const _hoisted_70 = { class: "col-sm-8" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("h6", { class: "h6 my-4" }, "Mis pruebas seleccionadas", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-2 text-hover-danger me-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.t('acrd2')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.form,
        "status-icon": "",
        rules: _ctx.rules,
        class: "form form-label-right"
      }, {
        default: _withCtx(() => [
          (_ctx.idsport == '3' || _ctx.idsport == '4' || _ctx.idsport == '5'
                    || _ctx.idsport == '6' || _ctx.idsport == '7' || _ctx.idsport == '16' || _ctx.idsport == '17' || _ctx.idsport == '42'
                    || _ctx.idsport == '27' || _ctx.idsport == '46' || _ctx.idsport == '41')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t('acrd3')), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_form_item, {
                      prop: "elofide",
                      rules: [
                                {
                                    required: true,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.elofide,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.elofide) = $event)),
                          maxlength: "2"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('acrd4')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_el_form_item, {
                      prop: "param1",
                      rules: [
                                {
                                    required: true,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.form.param1,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.param1) = $event)),
                          filterable: "",
                          placeholder: "Seleccione"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSetting?.positions, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: `lstpo-${index}`,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.idsport == '19')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_el_form_item, {
                      prop: "idteam",
                      rules: [
                                {
                                    required: false,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.form.idteam,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.idteam) = $event)),
                          filterable: "",
                          placeholder: "Seleccione"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSetting.cmp, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: `lstc-${index}`,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_el_form_item, {
                      prop: "param1",
                      rules: [
                                {
                                    required: false,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.form.param1,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.param1) = $event)),
                          filterable: "",
                          placeholder: "Seleccione"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSetting.nv, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: `lstc-${index}`,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_el_form_item, {
                      prop: "elofide",
                      rules: [
                                {
                                    required: true,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.elofide,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.elofide) = $event)),
                          maxlength: "50"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_el_form_item, {
                      prop: "titlefide",
                      rules: [
                                {
                                    required: true,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.titlefide,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.titlefide) = $event)),
                          maxlength: "50"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.form.param1 == 'AZ')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_el_form_item, {
                          prop: "note",
                          rules: [
                                {
                                    required: true,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.form.note,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.note) = $event)),
                              maxlength: "50"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.idsport == '2' || _ctx.idsport == '10' || _ctx.idsport == '11' || _ctx.idsport == '28' || _ctx.idsport == '15'
                    || _ctx.idsport == '25' || _ctx.idsport == '9' || _ctx.idsport == '8' || _ctx.idsport == '24')
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_el_form_item, {
                      prop: "idteam",
                      rules: [
                                {
                                    required: false,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.form.idteam,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.idteam) = $event)),
                          filterable: "",
                          placeholder: "Seleccione",
                          onChange: _ctx.getTest
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSetting.cmp, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: `lstc-${index}`,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.listSetting?.nv)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_el_form_item, {
                          prop: "idniv",
                          rules: [
                                {
                                    required: false,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              modelValue: _ctx.form.idniv,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.idniv) = $event)),
                              filterable: "",
                              placeholder: "Seleccione",
                              onChange: _ctx.getTest
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSetting.nv, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: `lstc-${index}`,
                                    label: item.name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_el_form_item, {
                      prop: "idtest",
                      rules: [
                                {
                                    required: false,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.form.idtest,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.idtest) = $event)),
                          filterable: "",
                          placeholder: "Seleccione"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTest, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: `lstc-${index}`,
                                label: item.name,
                                value: item.code
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_38, [
                                    (item.name != '' || item.name)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(item.abrev) + " - ", 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.idsport == '24')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_el_form_item, {
                          "label-width": "120px",
                          prop: "param1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.form.param1,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.param1) = $event)),
                              maxlength: "3"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.saveTest,
                    loading: _ctx.loadingTest
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Agregar prueba")
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"]),
                  _hoisted_44,
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    data: _ctx.listMiTest,
                    border: "",
                    stripe: "",
                    class: "p-0 m-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "competencia",
                        label: "Competencia"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "categoria",
                        label: "Categoria"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "nivel",
                        label: "Nivel"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "test",
                        label: "Prueba"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", _hoisted_45, [
                            (scope.row.abrev != '' && scope.row.abrev != null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(scope.row.abrev) + " - ", 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(scope.row.test), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        fixed: "right",
                        prop: "address",
                        label: "OP",
                        width: "80"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_popconfirm, {
                            width: "220",
                            title: "Eliminar prueba?",
                            "confirm-button-text": "SI",
                            "cancel-button-text": "No, gracias",
                            onConfirm: ($event: any) => (_ctx.onDeleteTest(scope.row.id))
                          }, {
                            reference: _withCtx(() => [
                              _hoisted_47
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])), [
                    [_directive_loading, _ctx.loadingTest]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.idsport == '13')
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_el_form_item, {
                      prop: "idteam",
                      rules: [
                                {
                                    required: false,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.form.idteam,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.idteam) = $event)),
                          filterable: "",
                          placeholder: "Seleccione",
                          onChange: _ctx.getTest
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSetting.cmp, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: `lstc-${index}`,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_el_form_item, {
                      prop: "param1",
                      rules: [
                                {
                                    required: false,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.form.idtest,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.idtest) = $event)),
                          filterable: "",
                          placeholder: "Seleccione"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTest, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: `lstc-${index}`,
                                label: item.name,
                                value: item.code
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.saveTest,
                    loading: _ctx.loadingTest
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Agregar prueba")
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"]),
                  _hoisted_56,
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    data: _ctx.listMiTest,
                    border: "",
                    stripe: "",
                    class: "p-0 m-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "cmp",
                        label: "Competencia"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "categoria",
                        label: "Categoria"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "nivel",
                        label: "Nivel"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "test",
                        label: "Prueba"
                      }),
                      _createVNode(_component_el_table_column, {
                        fixed: "right",
                        prop: "address",
                        label: "OP",
                        width: "80"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_popconfirm, {
                            width: "220",
                            title: "Eliminar prueba?",
                            "confirm-button-text": "SI",
                            "cancel-button-text": "No, gracias",
                            onConfirm: ($event: any) => (_ctx.onDeleteTest(scope.row.id))
                          }, {
                            reference: _withCtx(() => [
                              _hoisted_57
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])), [
                    [_directive_loading, _ctx.loadingTest]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.idsport == '14' || _ctx.idsport == '12')
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                (_ctx.idsport == '14')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _hoisted_60,
                      _createElementVNode("div", _hoisted_61, [
                        _createVNode(_component_el_form_item, {
                          prop: "elofide",
                          rules: [
                                {
                                    required: true,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              modelValue: _ctx.form.elofide,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.elofide) = $event)),
                              filterable: "",
                              placeholder: "Seleccione"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSetting.ranking, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: `lstc-${index}`,
                                    label: item.name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("div", _hoisted_64, [
                    _createVNode(_component_el_form_item, {
                      prop: "idteam",
                      rules: [
                                {
                                    required: false,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.form.idteam,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.idteam) = $event)),
                          filterable: "",
                          placeholder: "Seleccione",
                          onChange: _ctx.getTest
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSetting.cmp, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: `lstc-${index}`,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createElementVNode("div", _hoisted_67, [
                    _createVNode(_component_el_form_item, {
                      prop: "param1",
                      rules: [
                                {
                                    required: false,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.form.idtest,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.idtest) = $event)),
                          filterable: "",
                          placeholder: "Seleccione"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTest, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: `lstc-${index}`,
                                label: item.name,
                                value: item.code
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.form.idtest == 'PB0164' || _ctx.form.idtest == 'PB0165')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _hoisted_69,
                      _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_el_form_item, {
                          prop: "param1",
                          rules: [
                                {
                                    required: false,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.form.param1,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.param1) = $event)),
                              maxlength: "50"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_71, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.saveTest,
                    loading: _ctx.loadingTest
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Agregar prueba")
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"]),
                  _hoisted_72,
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    data: _ctx.listMiTest,
                    border: "",
                    stripe: "",
                    class: "p-0 m-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "cmp",
                        label: "Competencia"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "categoria",
                        label: "Categoria"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "nivel",
                        label: "Nivel"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "test",
                        label: "Prueba"
                      }),
                      _createVNode(_component_el_table_column, {
                        fixed: "right",
                        prop: "address",
                        label: "OP",
                        width: "80"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_popconfirm, {
                            width: "220",
                            title: "Eliminar prueba?",
                            "confirm-button-text": "SI",
                            "cancel-button-text": "No, gracias",
                            onConfirm: ($event: any) => (_ctx.onDeleteTest(scope.row.id))
                          }, {
                            reference: _withCtx(() => [
                              _hoisted_73
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])), [
                    [_directive_loading, _ctx.loadingTest]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ])), [
    [_directive_loading, _ctx.loader]
  ])
}